import { useSelector } from "react-redux";
import { selectorSrcmProfile } from "../state/selectors";

const NonSignedInOnlySection = ({ children = null }) => {
  const srcmProfile = useSelector(selectorSrcmProfile);
  if (!srcmProfile) {
    return children;
  }
  return null;
};

export default NonSignedInOnlySection;
